
export class AdditionalConstructionFileData {

  id: number;
  partDescription: string;
  additionalInfo: string;
  partDescriptionAdminChanges: string;
  additionalInfoAdminChanges: string;
  constructionYear: string;

}
